module.exports = __webpack_public_path__ + "img/soln-meta-kafka.61a30f09.jpg";